(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-box-featured-review"] && !Shopify.designMode) return;
  try {
    // Review carousel — vanilla JS, no framework. Supports multiple sliders
 // per page. Honors prefers-reduced-motion by disabling autoplay.
 (function() {
 if (window.__reviewSliderWired) return;
 window.__reviewSliderWired = true;

 const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

 function init(slider) {
 if (slider.dataset.reviewSliderReady) return;
 slider.dataset.reviewSliderReady = '1';

 const slides = slider.querySelectorAll('[data-review-slide]');
 const dots = slider.querySelectorAll('[data-review-goto]');
 const total = slides.length;
 if (total < 2) return;

 let active = 0;
 let timer = null;
 const autoplay = slider.dataset.autoplay === '1' && !prefersReduced;
 const intervalMs = parseInt(slider.dataset.interval, 10) || 5000;

 function go(i) {
 active = ((i % total) + total) % total;
 slides.forEach((slide, idx) => slide.classList.toggle('is-active', idx === active));
 dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === active));
 if (autoplay) start();
 }

 function start() {
 if (!autoplay) return;
 stop();
 timer = setInterval(() => go(active + 1), intervalMs);
 }

 function stop() {
 if (timer) { clearInterval(timer); timer = null; }
 }

 slider.addEventListener('click', (e) => {
 const prev = e.target.closest('[data-review-prev]');
 const next = e.target.closest('[data-review-next]');
 const goto = e.target.closest('[data-review-goto]');
 if (prev) return go(active - 1);
 if (next) return go(active + 1);
 if (goto) return go(parseInt(goto.dataset.reviewGoto, 10) || 0);
 });

 if (autoplay) {
 slider.addEventListener('mouseenter', stop);
 slider.addEventListener('mouseleave', start);
 start();
 }
 }

 function initAll(root) {
 (root || document).querySelectorAll('[data-review-slider]').forEach(init);
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
 } else {
 initAll();
 }
 document.addEventListener('shopify:section:load', (e) => initAll(e.target));
 })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy-box-ugc-carousel"] && !Shopify.designMode) return;
  try {
    // Horizontal scroll carousel — delegated listener, works for every
  // [data-scroll-carousel] wrapper on the page. No framework needed.
  (function() {
    if (window.__scrollCarouselWired) return;
    window.__scrollCarouselWired = true;
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-scroll-prev], [data-scroll-next]');
      if (!btn) return;
      const carousel = btn.closest('[data-scroll-carousel]');
      if (!carousel) return;
      const track = carousel.querySelector('[data-scroll-track]');
      if (!track) return;
      const delta = btn.hasAttribute('data-scroll-next') ? 200 : -200;
      track.scrollBy({ left: delta, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-sidebar"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__productGallerySidebarWired) return;
    window.__productGallerySidebarWired = true;

    function setFeatured(root, src, zoomSrc) {
      const img = root.querySelector('[data-gallery-featured]');
      if (!img) return;
      if (src) {
        img.src = src;
        if (zoomSrc) img.setAttribute('data-zoom-src', zoomSrc);
      }
      root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        const isActive = thumb.dataset.imageSrc === src;
        thumb.classList.toggle('is-active', isActive);
      });
    }

    // Thumbnail clicks — delegated
    document.addEventListener('click', (e) => {
      const thumb = e.target instanceof Element ? e.target.closest('[data-gallery-thumb]') : null;
      if (!thumb) return;
      const root = thumb.closest('[data-product-gallery-sidebar]');
      if (!root) return;
      setFeatured(root, thumb.dataset.imageSrc, thumb.dataset.imageZoomSrc);
    });

    // Variant changes — update featured image + sale badge from the matched variant
    document.addEventListener('variant:changed', (e) => {
      const variant = e.detail && e.detail.variant;
      if (!variant) return;
      const root = document.querySelector('[data-product-gallery-sidebar]');
      if (!root) return;

      // Featured image: try to find a thumbnail whose src matches the
      // variant's featured_image id. If not found, leave the image alone.
      if (variant.featured_image && variant.featured_image.id) {
        const wantedId = String(variant.featured_image.id);
        const thumbs = root.querySelectorAll('[data-gallery-thumb]');
        for (const t of thumbs) {
          const imgChild = t.querySelector('img');
          if (!imgChild) continue;
          // Match on the image basename fragment. Shopify image IDs do not
          // appear in the URL directly, so we fall back to index-based
          // matching via variant.featured_image.position minus 1.
          if (t.dataset.imageId && t.dataset.imageId === wantedId) {
            setFeatured(root, t.dataset.imageSrc, t.dataset.imageZoomSrc);
            break;
          }
        }
        // Position-based fallback (Shopify orders images by position)
        if (variant.featured_image.position) {
          const t = thumbs[variant.featured_image.position - 1];
          if (t) setFeatured(root, t.dataset.imageSrc, t.dataset.imageZoomSrc);
        }
      }

      // Sale badge
      const badge = root.querySelector('[data-gallery-sale-badge]');
      if (badge && variant.price != null && variant.compare_at_price != null) {
        if (variant.compare_at_price > variant.price) {
          const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          badge.textContent = '-' + pct + '%';
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
    if (window.__productGalleryVariantWired) return;
    window.__productGalleryVariantWired = true;

    const LAYOUTS = [
      { container: '.product-gallery__mobile', featured: 'product-gallery__mobile-item--featured' },
      { container: '.product-gallery__mosaic', featured: 'product-gallery__mosaic-item--featured', full: 'product-gallery__mosaic-item--full' },
      { container: '.product-gallery__stacked', featured: 'product-gallery__stacked-item--featured' }
    ];

    // product-form.js emits variant:changed with { variant, featuredImageId }.
    // The matched [data-image-id] item gets the --featured class (CSS order: -1);
    // in mosaic with data-first-full, it also takes over the full-width slot.
    document.addEventListener('variant:changed', (e) => {
      const rawId = e.detail && e.detail.featuredImageId;
      const featuredId = rawId ? String(rawId) : null;
      document.querySelectorAll('.product-gallery').forEach((gallery) => {
        LAYOUTS.forEach((layout) => {
          const container = gallery.querySelector(layout.container);
          if (!container) return;
          const items = container.querySelectorAll('[data-image-id]');
          let featuredItem = null;
          items.forEach((item) => {
            const isFeatured = featuredId !== null && item.dataset.imageId === featuredId;
            item.classList.toggle(layout.featured, isFeatured);
            if (isFeatured) featuredItem = item;
          });
          if (layout.full && container.hasAttribute('data-first-full')) {
            items.forEach((item) => item.classList.remove(layout.full));
            const fullTarget = featuredItem || items[0];
            if (fullTarget) fullTarget.classList.add(layout.full);
          }
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
